{
  "version": 1,
  "asset_id": "40932a97-1bf1-4953-9105-a3e308aef4ca",
  "project_id": "b5943ba6-0f61-4928-b23c-a966ef99f6df",
  "url": "/__l5e/assets-v1/40932a97-1bf1-4953-9105-a3e308aef4ca/reel-2.mp4",
  "r2_key": "a/v1/b5943ba6-0f61-4928-b23c-a966ef99f6df/40932a97-1bf1-4953-9105-a3e308aef4ca/reel-2.mp4",
  "original_filename": "reel-2.mp4",
  "size": 1778790,
  "content_type": "video/mp4",
  "created_at": "2026-08-19T12:43:50Z"
}
